import getHourAndMinute from './getHourAndMinute';

export default function getRelativeDate(date: string) {
  const recentSearchDate = new Date(date);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const dateDiff =
    (currentDate.getTime() - recentSearchDate.getTime()) /
    (1000 * 60 * 60 * 24);

  if (dateDiff < 1) {
    return `Today at ${getHourAndMinute(recentSearchDate)}`;
  } else if (dateDiff < 2) {
    return `Yesterday at ${getHourAndMinute(recentSearchDate)}`;
  } else {
    return recentSearchDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }
}
